import React from 'react';
import styled from 'styled-components';
import { Button, Modal, Tooltip } from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  CopyOutlined,
} from '@ant-design/icons';

import CustomSelect from '../../common/CustomSelect';
import ExecuteDashboard from '../../../containers/dashboards/cards/ButtonExecuteDashboard';
import DocsLink from '../../docs/DocsLink';
import docsBookmarks from '../../../constants/docs';

const StyledHeader = styled.div`
  margin: 0 45px 20px 45px;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;

  .dashboard-select {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;

    .dashboard-label {
      //padding-top: 5px;
      margin-right: 20px;
      white-space: nowrap;
    }
  }
`;

const StyledCustomSelect = styled(CustomSelect)`
  min-width: 256px;
  width: auto;

  .ant-select-selection-item {
    font-weight: bold;
  }
`;

const StyledCreateButton = styled(Button)`
  margin: 0 10px;
  border: 1px solid transparent;
`;

const StyledEditButton = styled(Button)`
  margin-right: 10px;
  border: 1px solid transparent;
`;

const StyledDeleteButton = styled(Button)`
  border: 1px solid transparent;
`;

const { confirm } = Modal;

const SelectedDashboardHeader = (props) => {
  const {
    dashboards,
    setSelectedDashboard,
    selectedDashboard,
    dashboardsObj,
    isDisableExecute,
    isDashboardManagePermission,
    onCreate,
    onUpdate,
    onCopy,
    dashboard,
    onDelete,
  } = props;

  const showDeleteConfirm = () => {
    confirm({
      title: 'Are you sure delete the dashboard?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDelete();
      },
      onCancel() {},
    });
  };

  return (
    <StyledHeader>
      <div className="dashboard-select">
        <span className="dashboard-label">Current dashboard:</span>
        <StyledCustomSelect
          defaultValue={dashboardsObj[selectedDashboard] || { name: '' }}
          values={dashboards}
          onChange={(id) => setSelectedDashboard(id)}
        />
        {isDashboardManagePermission && (
          <>
            <Tooltip title="Create dashboard">
              <StyledCreateButton size="small" onClick={onCreate}>
                <PlusOutlined />
              </StyledCreateButton>
            </Tooltip>
            <Tooltip title="Edit dashboard">
              <StyledEditButton onClick={onUpdate} size="small" disabled={!selectedDashboard}>
                <EditOutlined />
              </StyledEditButton>
            </Tooltip>
            <Tooltip title="Copy dashboard">
              <StyledEditButton onClick={onCopy} size="small">
                <CopyOutlined />
              </StyledEditButton>
            </Tooltip>
            <Tooltip title="Delete dashboard">
              <StyledDeleteButton
                size="small"
                disabled={!selectedDashboard}
                onClick={showDeleteConfirm}
              >
                <DeleteOutlined />
              </StyledDeleteButton>
            </Tooltip>
          </>
        )}
      </div>
      <ExecuteDashboard dashboard={dashboard} isDisableExecute={isDisableExecute} />
      <DocsLink
        scrolTo={docsBookmarks.dashboards}
        styleIcon={{ fontSize: 20, margin: 5, color: 'gray' }}
      />
    </StyledHeader>
  );
};

export default SelectedDashboardHeader;
